<template>
  <div class="wrapper">
    <div class="nav-list-wrap">
      <div class="nav-list">
        <!-- 视频分类 -->
        <template v-if="$route.name == 'video' || $route.name == 'videoclassify'">
          <div
            class="nav"
            v-for="(item,index) in videoMenu"
            :key="index"
            @mouseover="hoverIndex = index"
            @mouseout="hoverIndex=-1"
          >

            <router-link :to="{name:'videoclassify',query:{id: item.id}}" >
              <a href="javascript:;" class="nav-link">
                <span>{{item.type_name}}</span>
                <!-- {{item}} -->
                <i class="el-icon-arrow-right"></i>
              </a>
            </router-link>
            <transition name="el-fade-in">
              <div class="shop-list-wrap">
                <div class="shop-list" v-show="hoverIndex==index" @mouseover="hoverIndex = index">
                  <div class="shop-ul" v-show="item.child.length > 0">
                    <div v-for="(product,ulIndex) in item.child" :key="ulIndex"  class="shop">
                      <router-link :to="{name:'videoclassify',query:{id:product.id}}" 
                      @click.native="hideList">
                        <span class="shop-text">{{product.type_name}}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </template>


        <div
          v-else
          class="nav"
          v-for="(item,index) in allList"
          :key="index"
          @mouseover="hoverIndex = index"
          @mouseout="hoverIndex=-1"
        >
         <router-link :to="{ name:'search',query: {id: item.id, name: item.name} }">
            <a href="javascript:;" class="nav-link">
              <span>{{item.name}}</span>
              <i class="el-icon-arrow-right"></i>
            </a>
          </router-link>

          <transition name="el-fade-in">
            <div class="shop-list-wrap">
              <div class="shop-list" v-show="hoverIndex==index" @mouseover="hoverIndex = index">
                <div class="shop-ul" v-show="item.child">
                  <div v-for="(product,ulIndex) in item.child" :key="ulIndex" class="shop">
                    <router-link :to="{name:'search',query:{id:product.id,name:product.name}}" 
                    @click.stop="hideList">
                      <span class="shop-text">{{product.name}}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AllClassify",
  components: {},
  props: {},
  data() {
    return {
      allList: [],
      hoverIndex: -1,
      videoMenu: []
    };
  },
  watch: {
    '$route'() {
      if(this.$route.name == 'video' || this.$route.name == 'videoclassify') {
        this.videoclassify()
      }
    }
  },
  computed: {},
  methods: {
    // 获取视频分类
    videoclassify() {
      this.$api.gettypetist().then(res => {
        if(res.status) {
          this.videoMenu =  res.data.list
        }
      })
    },
    //获取所有商品分类
    categories() {
      this.$api.categories().then(res => {
        if (res.status) {
          this.allList = res.data;
        }
      });
    },
    hideList(){
      this.hoverIndex=-1
    }
  },
  created() {
    if(this.$route.name == 'video' || this.$route.name == 'videoclassify') {
      this.videoclassify()
    } else {
      this.categories();
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrapper {
  position: relative;
  .nav-list-wrap {
    position: absolute;
    top: 0;
    // left: 0;
    left: -26px;
    width: 234px;
    height: 440px;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
    .nav-list {
      position: relative;
      .nav a.nav-link {
        width: 234px;
        height: 38px;
        padding: 0 20px 0 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        box-sizing: border-box;
        position: relative;
        &:hover {
          background: $theme-color;
          color: #fff;
        }
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
        }
      }

      .shop-list-wrap {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 234px;
        height: 440px;
        background: #fff;
        overflow: hidden;
        // border-right: 1px solid #e0e0e0;
        // border-bottom: 1px solid #e0e0e0;
        .shop-list {
          width:780px;
          height: 400px;
          background: #fff;
          border-left: 0;
          display: flex;
          padding: 10px 20px;
          flex-wrap: wrap;
          box-sizing: border-box;
          &.active {
            display: block;
            z-index: 20;
          }
          .shop-ul {
            height: 34px;
            .shop {
              display: block;
              float: left;
              writing-mode: horizontal-tb;
              position: relative;
              width: 235px;
              height: 34px;
              line-height: 73px;
              a {
                display: block;
                text-align: left;
                width: 100%;
                height: 100%;
                // padding: 18px 20px;
                line-height: 40px;
                color: #333;
                -webkit-transition: color 0.2s;
                transition: color 0.2s;
                box-sizing: border-box;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                &:hover {
                  color: $theme-color;
                }
                img {
                  display: inline-block;
                  width: 35px;
                  height: 35px;
                  object-fit: contain;
                  margin-right: 12px;
                  vertical-align: middle;
                }
                .text {
                  line-height: 40px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>